module.exports = __webpack_public_path__ + "static/img/otros_servicios.7a6854f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/otros_servicios.jpg
// module id = ESIL
// module chunks = 1